/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox, Image } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';
import './styles.scss';
import { isUrlImageValid } from '../../../../../utils/checkImage';

const NOT_FOUND_IMAGE = 'https://dashboard-v2-images.s3.amazonaws.com/not-found.png';

const ProductsV2Card = props => {
  const {
    id,
    image,
    title,
    description,
    onClick,
    hasImage,
    isClientPage,
    selectedProducts,
    toggleProductSelection,
    selectedAndDisabledProducts,
  } = props;

  const [hasImageValid, setHasImageValid] = useState(true);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (image) {
      isUrlImageValid(image).then(isValid => setHasImageValid(isValid));
    }
  }, [image]);

  const handleSelect = useCallback(
    e => {
      console.log({ select: e });
      e.stopPropagation();
      e.preventDefault();
      if (isClientPage) {
        toggleProductSelection(id);
      }
    },
    [isClientPage],
  );

  return hasImageValid || !hasImage ? (
    <div
      className="products-v2-card"
      onClick={e => {
        console.log({ e });
        onClick();
      }}
    >
      {!!isClientPage && (
        <Checkbox
          checked={selectedProducts?.has(id)}
          onChange={handleSelect}
          disabled={selectedAndDisabledProducts?.has(id)}
        />
      )}
      <div className="products-v2-card__image">
        <Image
          src={image || NOT_FOUND_IMAGE}
          fallback={NOT_FOUND_IMAGE}
          preview={false}
          alt="product"
          onLoad={() => setLoading(false)}
          onError={() => setHasImageValid(false)}
          width="40px"
          height="40px"
        />
      </div>
      <div className="products-v2-card__body">
        {loading && !!hasImage ? (
          <LoadingOutlined style={{ color: '#33aafc' }} />
        ) : (
          <>
            <span className="products-v2-card__title line-clamp-1">{title}</span>
            <span className="products-v2-card__description line-clamp-1">{description}</span>
          </>
        )}
      </div>
    </div>
  ) : null;
};

export default ProductsV2Card;
